<template>
  <div class="table-idp-activities" :style="!items.length ? 'padding-bottom: 30px' : ''">
    <div class="adp-grid-row adp-grid-row__employee_idp">
      <div class="adp-grid-cell adp-grid-cell__chbox">
        <b-form-checkbox v-model="selectAll" :indeterminate="selectAllIndeterminate" @change="selectAllHandler($event)">&nbsp;</b-form-checkbox>
      </div>
      <div class="d-flex flex-column adp-grid-cell__head">
        <div @click="sortChange('group')">
          <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'group'}">
            {{ $t('voc.table_group') }}
          </span>
          <span class="adp-th adp-th__sort__icon">
            <img :src="getSortingIcon('group')" alt="sort">
          </span>
        </div>
        <my-dropdown :options="groups" :init-selected="filterGroups" :has-select-all="true"
                     v-on:my-change="onDropdownUpdate($event, 'filterGroups', 'groups')" :localize="false" :readonly="false">
        </my-dropdown>
      </div>
      <div class="d-flex flex-column adp-grid-cell__head">
        <div @click="sortChange('competence')">
          <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'competence'}">
            {{ $t('catalog.competencies') }}
          </span>
          <span class="adp-th adp-th__sort__icon">
            <img :src="getSortingIcon('competence')" alt="sort">
          </span>
        </div>
        <my-dropdown :options="competencies" :init-selected="filterCompetencies" :has-select-all="true"
                     v-on:my-change="onDropdownUpdate($event, 'filterCompetencies', 'competencies')" :localize="false" :readonly="false">
        </my-dropdown>
      </div>
      <div class="d-flex flex-column adp-grid-cell__head">
        <div @click="sortChange('format')">
          <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'format'}">
            {{ $t('voc.table_format') }}
          </span>
          <span class="adp-th adp-th__sort__icon">
            <img :src="getSortingIcon('format')" alt="sort">
          </span>
        </div>
        <my-dropdown :options="formats" :init-selected="filterFormats" :has-select-all="true"
                     v-on:my-change="onDropdownUpdate($event, 'filterFormats', 'formats')" :readonly="false">
        </my-dropdown>
      </div>
      <div class="d-flex flex-column adp-grid-cell__head">
        <div @click="sortChange('name')">
          <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'name'}">
            {{ $t('voc.table_name') }}
          </span>
          <span class="adp-th adp-th__sort__icon">
            <img :src="getSortingIcon('name')" alt="sort">
          </span>
        </div>
        <input @input="filterAndSortItems" type="text" class="adp-input adp-input__catalog adp-input-search" v-model="filterName">
      </div>
      <div class="d-flex flex-column adp-grid-cell__head">
        <div @click="sortChange('deadline')">
          <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'deadline'}">
            {{ $t('voc.table_deadline') }}
          </span>
          <span class="adp-th adp-th__sort__icon">
            <img :src="getSortingIcon('deadline')" alt="sort">
          </span>
        </div>
        <my-date-picker @change="changeDateInterval($event)" :dates="deadlines" :range="true" :idpYear="idpYear"/>
      </div>
      <div class="d-flex flex-column adp-grid-cell__head">
        <div @click="sortChange('status_ru')">
          <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'status_ru'}">
            {{ $t('voc.table_status') }}
          </span>
          <span class="adp-th adp-th__sort__icon">
            <img :src="getSortingIcon('status_ru')" alt="sort">
          </span>
        </div>
        <my-dropdown :options="statuses" :init-selected="filterStatuses" :has-select-all="true"
                     v-on:my-change="onDropdownUpdate($event, 'filterStatuses', 'statuses')">
        </my-dropdown>
      </div>
    </div >

    <template v-if="items.length">
      <div class="adp-grid-row adp-grid-row__employee_idp" v-for="(item, i) in items" :key="i"
           style="cursor: pointer" @click="$emit('learning-click', item)">
        <div class="adp-grid-cell adp-grid-cell__chbox-hr" @click.stop>
          <b-form-checkbox v-model="item.is_checked" @change="selectEvent" @click.stop/>
        </div>
        <div class="adp-grid-cell adp-grid-cell__title">
          {{ item.competence_group ? item.competence_group.name : '' }}
        </div>
        <div class="adp-grid-cell">
        <span class="adp-grid-cell adp-grid-cell__title">
          <template v-if="item.competencies.length">
            {{ item.competencies.map(c => c.name).join(', ') }}
          </template>
        </span>
        </div>
        <div class="adp-grid-cell adp-grid-cell__title">
          {{ $t(`idp.format_${item.la_format}`) }}
        </div>
        <div class="adp-grid-cell adp-grid-cell__title">
          {{ item.name }}
        </div>
        <div class="adp-grid-cell adp-grid-cell__title">
          {{ item.deadline ? `${$t('idp.till')} ${item.deadline}` : '' }}
        </div>
        <div class="adp-grid-cell adp-grid-cell__title" :style="`color: ${textColor(item.status)}`">
          <div style="width: 65%">{{ getStatus(item) }}</div>
          <div class="d-flex flex-column">
            <div v-if="item.comments.length" style="cursor: pointer; display: flex"
                 @click.stop="$emit('show-comments-modal', item.comments, item.name, item.id)"
            >
              <img src="/images/comment.svg" style="height: 25px" alt="" v-if="isAllCommentsRead(item.comments)">
              <img src="/images/comment-yellow.svg" v-else alt="">
              <span :style="isAllCommentsRead(item.comments) ? 'color: #9FBF00' : 'color: #FFAA01'">
                {{ item.comments.length }}
              </span>
            </div>
            <div v-if="item.files.length" style="cursor: pointer; display: flex"
                 @click.stop="$emit('show-files-modal', item.files, item.name, item.id)"
            >
              <img src="/images/paperclip.svg" style="height: 25px" alt="" v-if="isAllFilesViewed(item.files)">
              <img src="/images/paperclip-yellow.svg" v-else style="width: 24px" alt="">
              <span :style="isAllFilesViewed(item.files) ? 'color: #9FBF00' : 'color: #FFAA01'">
                {{ item.files.length }}
              </span>
            </div>
          </div>
          <div style="padding: 0 8px; cursor: pointer" @click.stop="$emit('click-dots', $event, IDP.id, item)">
            <img src="/images/vertical_dots.svg" alt="">
          </div>
        </div>
      </div >
    </template>

    <template v-else>
      <span class="adp-th" style="font-size: 20px; margin-left: 45px">{{ $t('idp.empty_learnings_list') }}</span>
    </template>
  </div>
</template>

<script>
import MyDropdown from "./MyDropdown";
import MyDatePicker from "./MyDatePicker";
import api from "../api";


export default {
  name: "EmployeeTableIDPLearnings",
  components: {
    'my-dropdown': MyDropdown,
    'my-date-picker': MyDatePicker,
  },
  props: {
    vals: {
      type: Array,
      required: true
    },
    IDP: {
      type: Object,
      required: true,
    },
    idpYear: {
      default: null
    }
  },
  data: () => {
    return {
      items: [],
      assignItems: {},

      selectAll: false,
      selectAllIndeterminate: false,

      isActiveCompetence: false,

      sortColumn: '',
      sortDirection: '',
      lastUsedFilterOptions: '',

      filterName: '',
      filterCompetencies: [],
      filterFormats: [],
      filterGroups: [],
      filterDeadlines: [],
      filterStatuses: [],

      formats: [],
      groups: [],
      deadlines: [],
      statuses: [],
      competencies: [],
    }
  },
  computed: {

  },
  methods: {
    changeDateInterval(e) {
      this.filterDeadlines = (e !== null && e[0] !== null && e[1] !== null) ? e : [];
      this.filterAndSortItems();
    },
    isAllFilesViewed(files) {
      const notAllFilesViewed = files.find(file => file.is_viewed === false)
      return !notAllFilesViewed;
    },
    isAllCommentsRead(comments) {
      const notAllCommentsRead = comments.find(comment => comment.is_read === false);
      return !notAllCommentsRead;
    },
    filterAndSortItems() {

      let items = this.vals;
      items.map(el => {
        el.competence = el.competencies[0] ? el.competencies[0].name : 0;
        el.group = el.competence_group ? el.competence_group.name : '';
        el.format = this.$t(`idp.format_${el.la_format}`);
        el.status_ru = this.$t(`idp.${el.status}`);
      })

      if (this.filterName) {
        this.filterName.length > 0
          ? items = items.filter(el => {
            return String(el.name).toLowerCase().includes(this.filterName)
              || String(el.name).includes(this.filterName)
          })
          : items = items.filter(el => el.name);
      }
      if (this.filterCompetencies.length > 0) {
        items = items.filter(el => {
          const competenciesIds = el.competencies.map(x => x.id);
          let result = false
          this.filterCompetencies.map(x => {
            if (competenciesIds.includes(x)) return result = true;
          })
          return result;
        });
      }
      if (this.filterFormats.length > 0) {
        items = items.filter(el => this.filterFormats.includes(el.la_format));
      }
      if (this.filterGroups.length > 0) {
        items = items.filter(el => this.filterGroups.includes(el.competence_group.id));
      }
      if (this.filterStatuses.length > 0) {
        items = items.filter(el => this.filterStatuses.includes(el.status));
      }
      if (this.filterDeadlines.length > 0) {
        if (this.filterDeadlines[0] === null) {
          items = this.vals;
        } else {
          items = items.filter(el => {
            let noPaddingDateParts = el.deadline.split('-').map(Number);
            let noPaddingDate = new Date(noPaddingDateParts[2], noPaddingDateParts[1] - 1, noPaddingDateParts[0]);
            return noPaddingDate >= this.filterDeadlines[0] && noPaddingDate <= this.filterDeadlines[1];
          });
        }
      }

      items.forEach(el => el.is_checked = false);
      this.items = items;
      
      this.sortItems();
      this.resetSelectedItems();

      this.items = JSON.parse(JSON.stringify(items)); // для корректного обновления чекбоксов

      this.updateFilterOptions();
    },
    sortChange(sortingColumn) {
      if (sortingColumn !== this.sortColumn) {
        this.sortColumn = sortingColumn;
        this.sortDirection = '';
      }

      if (this.sortDirection === '') {
        this.sortDirection = 'asc';
      } else if (this.sortDirection === 'asc') {
        this.sortDirection = 'desc';
      } else if (this.sortDirection === 'desc') {
        this.sortDirection = '';
        this.sortColumn = null;
      }

      this.sortItems();
    },
    sortItems() {
      function dynamicSort(property) {
        let sortOrder = 1;
        if (property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
        }
        return function (a, b) {
          let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
          return result * sortOrder;
        }
      }

      if (this.sortColumn) {
        let direction = this.sortDirection === 'desc' ? '-' : '';
        this.items.sort(dynamicSort(direction + this.sortColumn));
      } else {
        this.items.sort(dynamicSort('id'));
      }
    },
    updateFilterOptions() {
      if (this.lastUsedFilterOptions !== 'groups' || this.filterGroups.length === 0) {
        const uniqueGroups = new Map();
        this.items.map(x => {
          if (x.competence_group) uniqueGroups.set(x.competence_group.id, x.competence_group)
        })
        this.groups = [...uniqueGroups.values()].map(group => ({ id: group.id, code:group.name }));
      }

      if (this.lastUsedFilterOptions !== 'competencies' || this.filterCompetencies.length === 0) {
        const uniqueCompetences = new Map();
        this.items.map(item => {
          if (item.competencies.length) {
            item.competencies.forEach(comp => uniqueCompetences.set(comp.id, comp));
          }
        })
        this.competencies = [...uniqueCompetences.values()].map(comp => ({ id: comp.id, code: comp.name }));
      }

      if (this.lastUsedFilterOptions !== 'formats' || this.filterFormats.length === 0) {
        const uniqueFormats = new Map();
        this.items.map(x => {
          if (x.la_format) uniqueFormats.set(x.la_format, x.la_format)
        })
        this.formats = [...uniqueFormats.values()].map(format => ({ id: format, code: `format_${format}` }));
      }

      if (this.lastUsedFilterOptions !== 'statuses' || this.filterStatuses.length === 0) {
        const uniqueStatuses = new Map();
        this.items.map(x => {
          if (x.status) uniqueStatuses.set(x.status, x.status)
        })
        this.statuses = [...uniqueStatuses.values()].map(status => ({ id: status, code: status }));
      }
    },
    getSortingIcon(sortingColumn) {
      if (sortingColumn !== this.sortColumn || this.sortDirection === '') {
        return '/images/sort.svg';
      } else if (this.sortDirection === 'asc') {
        return '/images/sort_active_asc.svg';
      } else if (this.sortDirection === 'desc') {
        return '/images/sort_active_desc.svg';
      }
    },
    onDropdownUpdate(e, property, filterOptionsName) {
      this.lastUsedFilterOptions = filterOptionsName;
      this[property] = e;
      this.filterAndSortItems();
    },
    hide(prop) {
      this[prop] = false;
    },
    onChildrenUpdate(cmptcs) {
      let checkedCompetencies = new Set();
      cmptcs.map(cmptns => flatten(cmptns));

      function flatten(cmptns) {
        if (cmptns.isCompetence && cmptns.isChecked) {
          checkedCompetencies.add(cmptns.id)
        }
        if (cmptns.children && cmptns.children.length) {
          cmptns.children.map(cmp => flatten(cmp));
        }
      }
      this.filterCompetencies = Array.from(checkedCompetencies);
      this.filterAndSortItems();
    },
    selectAllHandler(event) {
      if (Object.keys(this.assignItems).length) {
        this.resetSelectedItems();
      } else {
        this.items = this.items.map(el => {el.is_checked = true; return el});
        this.selectAll = true;
        this.selectAllIndeterminate = false;
        this.updateItemsChecked();
      }
    },
    updateItemsChecked() {
      let items = {};
      let assignedItems = this.items.filter(el => el.is_checked).map(el => ({ ...el }));

      assignedItems.forEach(item => {
        items[item.id] = item
      })

      this.assignItems = items;
      if (Object.values(items).length) this.$emit('changeLearningAssignItems', items);
      else this.$emit('changeLearningAssignItems', {});
    },
    selectEvent() {
      let checkedElementsCnt = this.items.filter(el => el.is_checked).length;
      if (this.items.length === checkedElementsCnt) {
        this.selectAll = true;
        this.selectAllIndeterminate = false;
      } else if (this.items.length > checkedElementsCnt && checkedElementsCnt > 0) {
        this.selectAll = false;
        this.selectAllIndeterminate = true;
      } else {
        this.selectAll = false;
        this.selectAllIndeterminate = false;
      }

      this.updateItemsChecked();
    },
    formatDate(input) {
      if (!input || input === '-') {
        return '';
      }
      let datePart = input.match(/\d+/g);
      const year = datePart[0];
      const month = datePart[1];
      const day = datePart[2];

      return day + '.' + month + '.' + year;
    },
    textColor(status) {
      if (status === 'draft') return '#6D7278';
      if (status === 'done') return '#9fbf00';
      if (status === 'rejected') return '#E02020';
      return '#FFAA01';
    },
    getStatus(item) {
        return this.$t(`idp.${item.status}`);
    },
    resetSelectedItems() {
      this.items = this.items.map(el => {el.is_checked = false; return el});
      this.selectAll = false;
      this.selectAllIndeterminate = false;
      this.updateItemsChecked();
    },
  },
  mounted() {
    this.filterAndSortItems();
  }
}
</script>

<style scoped>

</style>
